import {Badge, Box, IconButton, Menu, MenuItem, Popover, Stack, Tab, Tabs, Typography, styled} from '@mui/material';

export const NotificationsButton = styled(IconButton)(() => ({
  width: 40,
  height: 40,
  color: '#80849D',
  backgroundColor: 'transparent',
  borderRadius: 4,
  '&:hover': {
    backgroundColor: '#F5F6FA',
  },
}));

export const NotificationsBadge = styled(Badge)(() => ({
  '& .MuiBadge-badge': {
    minWidth: 16,
    height: 16,
    padding: '0 4px',
    backgroundColor: '#F03939',
    color: '#FFFFFF',
    fontSize: 10,
    fontWeight: 500,
    lineHeight: '16px',
  },
}));

export const NotificationsPopover = styled(Popover)(() => ({
  '& .MuiPopover-paper': {
    width: 431,
    height: 560,
    marginTop: 24,
    marginLeft: 8,
    maxHeight: 'calc(100vh - 96px)',
    borderRadius: 8,
    overflow: 'hidden',
    boxShadow:
      '0px 41px 17px rgba(0, 0, 0, 0.01), 0px 23px 14px rgba(0, 0, 0, 0.03), 0px 10px 10px rgba(0, 0, 0, 0.05), 0px 3px 6px rgba(0, 0, 0, 0.06), 0px 0px 0px rgba(0, 0, 0, 0.06)',
  },
}));

export const NotificationsPanel = styled(Stack)(() => ({
  height: '100%',
  backgroundColor: '#F4F6FA',
}));

export const NotificationsHeader = styled(Stack)(() => ({
  height: 90,
  flexShrink: 0,
  backgroundColor: '#FFFFFF',
  borderBottom: '1px solid #DCDEE4',
  boxShadow:
    '0px 7px 4px rgba(0, 0, 0, 0.02), 0px 3px 3px rgba(0, 0, 0, 0.03), 0px 1px 2px rgba(0, 0, 0, 0.04), 0px 0px 0px rgba(0, 0, 0, 0.04)',
}));

export const NotificationsTitleRow = styled(Stack)(() => ({
  height: 56,
  padding: '16px 16px 0 24px',
}));

export const NotificationsTitle = styled(Typography)(() => ({
  fontWeight: 600,
  fontSize: 16,
  lineHeight: '24px',
  color: '#141414',
}));

export const NewCountBubble = styled(Box)(() => ({
  minWidth: 24,
  height: 24,
  padding: '0 7px',
  borderRadius: 15,
  backgroundColor: '#F03939',
  color: '#FFFFFF',
  fontWeight: 500,
  fontSize: 14,
  lineHeight: '24px',
  textAlign: 'center',
}));

export const HeaderActionsButton = styled(IconButton)(() => ({
  width: 24,
  height: 24,
  padding: 0,
  color: '#80849D',
}));

export const NotificationTabs = styled(Tabs)(() => ({
  minHeight: 34,
  height: 34,
  paddingLeft: 24,
  '& .MuiTabs-indicator': {
    height: 2,
    backgroundColor: '#0085FF',
  },
}));

export const NotificationTab = styled(Tab)(() => ({
  minWidth: 0,
  minHeight: 34,
  height: 34,
  padding: '2px 12px 8px',
  marginRight: 24,
  fontWeight: 500,
  fontSize: 12,
  lineHeight: '24px',
  color: '#696F8C',
  textTransform: 'none',
  '&.Mui-selected': {
    color: '#0085FF',
  },
}));

export const NotificationsList = styled(Stack)(() => ({
  flex: 1,
  overflowY: 'auto',
  backgroundColor: '#F4F6FA',
}));

export const NotificationRow = styled(Stack)(() => ({
  height: 94,
  flexShrink: 0,
  padding: '16px 16px 16px 24px',
  gap: 12,
  backgroundColor: '#FFFFFF',
  borderBottom: '1px solid #DCDEE4',
  cursor: 'pointer',
}));

export const NotificationContent = styled(Stack)(() => ({
  minWidth: 0,
  flex: 1,
  gap: 12,
  padding: '2px 0',
}));

export const NotificationText = styled(Stack)(() => ({
  gap: 8,
}));

export const NotificationTitle = styled(Typography)(() => ({
  fontWeight: 600,
  fontSize: 12,
  lineHeight: '14px',
  color: '#141414',
}));

export const NotificationMessage = styled(Typography)(() => ({
  fontWeight: 500,
  fontSize: 12,
  lineHeight: '18px',
  color: '#696F8C',
}));

export const NotificationDate = styled(Typography)(() => ({
  fontWeight: 500,
  fontSize: 12,
  lineHeight: '14px',
  color: '#696F8C',
}));

export const NewLabel = styled(Box)(() => ({
  height: 14,
  padding: '0 10px',
  borderRadius: 2,
  backgroundColor: '#3AC977',
  color: '#FFFFFF',
  fontWeight: 600,
  fontSize: 10,
  lineHeight: '14px',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
}));

export const NotificationMenuButton = styled(IconButton)(() => ({
  width: 24,
  height: 24,
  padding: 0,
  color: '#80849D',
}));

export const EmptyText = styled(Typography)(() => ({
  padding: 24,
  fontWeight: 500,
  fontSize: 12,
  lineHeight: '18px',
  color: '#696F8C',
}));

export const ActionMenu = styled(Menu)(() => ({
  '& .MuiPaper-root': {
    borderRadius: 8,
    boxShadow: '2px 3px 10px rgba(0, 0, 0, 0.25)',
  },
  '& .MuiList-root': {
    padding: '5px 0',
  },
}));

export const NotificationActionItem = styled(MenuItem)(() => ({
  minHeight: 36,
  padding: '8px 16px',
  fontWeight: 400,
  fontSize: 12,
  lineHeight: '20px',
  color: '#000000',
  '&:not(:last-of-type)': {
    borderBottom: '0.2px solid #B9B9B9',
  },
  '&:hover': {
    backgroundColor: '#F5F6FA',
    color: '#007DFF',
  },
}));

export const DeleteActionItem = styled(NotificationActionItem)(() => ({
  color: '#F03939',
  '&:hover': {
    backgroundColor: '#F5F6FA',
    color: '#F03939',
  },
}));

export const NotificationDetailsRoot = styled(Stack)(() => ({
  flex: 1,
  backgroundColor: '#F4F6FA',
  padding: '20px',
}));

export const NotificationDetailsHeader = styled(Stack)(() => ({
  height: 56,
  flexShrink: 0,
  padding: '16px 16px 0 24px',
  backgroundColor: '#FFFFFF',
  borderBottom: '1px solid #DCDEE4',
  boxShadow:
    '0px 7px 4px rgba(0, 0, 0, 0.02), 0px 3px 3px rgba(0, 0, 0, 0.03), 0px 1px 2px rgba(0, 0, 0, 0.04), 0px 0px 0px rgba(0, 0, 0, 0.04)',
}));

export const BackButton = styled(IconButton)(() => ({
  width: 24,
  height: 24,
  padding: 0,
  color: '#696F8C',
}));

export const NotificationDetailsCard = styled(Stack)(() => ({
  borderRadius: 8,
  backgroundColor: '#FFFFFF',
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  padding: '20px',
  gap: 12,
}));

export const NotificationDetailsTitle = styled(Typography)(() => ({
  fontFamily: 'Inter',
  fontWeight: 600,
  fontSize: 13,
  lineHeight: '16px',
  color: '#141414',
}));

export const NotificationDetailsMessage = styled(Typography)(() => ({
  fontFamily: 'Inter',
  fontWeight: 400,
  fontSize: 13,
  lineHeight: '20px',
  color: '#696F8C',
  textAlign: 'justify',
  whiteSpace: 'pre-wrap',
}));

export const NotificationDetailsDate = styled(Typography)(() => ({
  fontFamily: 'Inter',
  fontWeight: 500,
  fontSize: 12,
  lineHeight: '15px',
  color: '#696F8C',
}));
